<template>
    <div>
        <v-row style="margin-left:0.5px;font-size:20px"
            >Fortsätt att använda:
            <v-icon @click="auth('facebook')" class="icon"
                >fab fa-facebook-f</v-icon
            >
            <v-icon @click="auth('google')" class="icon"
                >fab fa-google-plus-g</v-icon
            >
        </v-row>
        <v-dialog v-model="loading" fullscreen>
            <v-container
                fluid
                fill-height
                style="background-color: rgba(255, 255, 255, 0.5);"
            >
                <v-layout justify-center align-center>
                    <v-progress-circular indeterminate color="primary">
                    </v-progress-circular>
                </v-layout>
            </v-container>
        </v-dialog>
    </div>
</template>

<script>
import store from "../../store";
export default {
    name: "socialLogin",
    store: store,
    data: () => ({
        sco: "",
        profile: {},
        loading:false
    }),
    methods: {
        auth: async function(network) {
            this.loading = true;
            if (network === "facebook") this.sco = "public_profile,email";
            else
                this.sco =
                    " https://www.googleapis.com/auth/plus.me https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile";

            await this.$hello(network).login({ scope: this.sco });
            await this.$hello(network)
                .api("me")
                .then(res => {
                    this.profile = res;
                });
            let bodyFormData = new FormData();
            bodyFormData.set("first_name", this.profile.first_name);
            if (network === "facebook")
                bodyFormData.set("last_name", this.profile.last_name);
            else bodyFormData.set("last_name", this.profile.family_name);
            bodyFormData.set("email", this.profile.email);
            bodyFormData.set("password", network);
            bodyFormData.set("c_password", network);
            bodyFormData.set("role", "user");
            const config = {
                method: "post",
                url: "",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };
            await this.$store
                .dispatch("socialLogin", config)
                .then(() => (this.loading = false))
                .catch(() => {
                    this.isLoading = false;
                });
            this.$router.replace("/");
            this.loading = false;
        }
    }
};
</script>

<style scoped>
.icon {
    margin-left: 5px;
    margin-right: 5px;
}
</style>
